'use client';
import { isNumber } from '@s7/utils';

var createUnitParser = function(param) {
    var suffix = param.suffix, parseUnit = param.parseUnit, lookup = param.lookup;
    return function(rawValue) {
        if (rawValue == undefined) {
            return parseUnit(null);
        }
        if (isNumber(rawValue)) {
            return "" + rawValue + "px";
        }
        var parseValue = function(value) {
            if (value.endsWith(suffix)) {
                return parseUnit(value.slice(0, -suffix.length));
            }
            var lookupFn = lookup == null ? void 0 : lookup[value];
            return lookupFn ? lookupFn(rawValue) : value;
        };
        return rawValue.split(" ").map(parseValue).join(" ");
    };
};

export { createUnitParser };
